<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>供需信息</BreadcrumbItem>
          <BreadcrumbItem>商机供需</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">商机供需</div>
      </div>
      <div class="f-tar"
           style="padding-top: 37px;">
        <Button @click="$router.push('/host/index/supply-info/business-opportunity')">返回</Button>
      </div>
    </div>
    <div class="layout-content">
      <!-- .company-info-basic .cib -->
      <div class="cib">
        <Row>
          <Col span="24">

          <div v-if="detailData.publishType!='制造供应链'">
            <el-descriptions class="margin-top"
                             title="供需详情"
                             :column="2">
              <template slot="extra">
                <el-button type="primary"
                           size="small">查看名片</el-button>
              </template>
              <el-descriptions-item label="采买类型">{{detailData.publishType}}</el-descriptions-item>
              <el-descriptions-item label="姓氏">{{detailData.name}}</el-descriptions-item>
              <el-descriptions-item label="产品类型">
                {{productType?productType:detailData.type2}}
              </el-descriptions-item>
              <el-descriptions-item label="公司/机构">{{detailData.companyName}}</el-descriptions-item>
              <el-descriptions-item label="采买数量">{{detailData.jobTitle}}</el-descriptions-item>
              <el-descriptions-item label="职务">{{detailData.name}}</el-descriptions-item>
              <el-descriptions-item label="交货区域">{{detailData.productArea?(JSON.parse(detailData.productArea)).toString():"无"| character}}</el-descriptions-item>
              <el-descriptions-item label="电话">{{detailData.phone}}</el-descriptions-item>
              <el-descriptions-item label="采购截止日期">{{detailData.endTime| dateFormat}}</el-descriptions-item>
              <el-descriptions-item label="邮箱">{{detailData.email}}</el-descriptions-item>
              <el-descriptions-item label="资质要求">{{detailData.condition}}</el-descriptions-item>
              <el-descriptions-item label="身份">{{detailData.idnentityType}}</el-descriptions-item>
            </el-descriptions>
            <div style="padding: 20px;background: ghostwhite;">
              <div style="font-size: 16px;">采购描述：</div>
              <div>{{detailData.remark}}</div>
            </div>
          </div>

          <div v-else>
            <el-descriptions class="margin-top"
                             title="供需详情"
                             :column="2">
              <template slot="extra">
                <el-button type="primary"
                           size="small">查看名片</el-button>
              </template>
              <el-descriptions-item label="采买类型">{{detailData.publishType}}</el-descriptions-item>
              <el-descriptions-item label="姓氏">{{detailData.name}}</el-descriptions-item>
              <el-descriptions-item label="产品类型">
                {{productType?productType:detailData.type2}}
              </el-descriptions-item>
              <el-descriptions-item label="公司/机构">{{detailData.companyName}}</el-descriptions-item>
              <el-descriptions-item label="采买数量">{{detailData.jobTitle}}</el-descriptions-item>
              <el-descriptions-item label="职务">{{detailData.name}}</el-descriptions-item>
              <el-descriptions-item label="供应商所在地">{{detailData.productArea?(JSON.parse(detailData.productArea)).toString():"无"| character}}</el-descriptions-item>
              <el-descriptions-item label="电话">{{detailData.phone}}</el-descriptions-item>
              <el-descriptions-item label="采购截止日期">{{detailData.endTime| dateFormat}}</el-descriptions-item>
              <el-descriptions-item label="邮箱">{{detailData.email}}</el-descriptions-item>
              <el-descriptions-item label="资质要求">{{detailData.condition}}</el-descriptions-item>
              <el-descriptions-item label="身份">{{detailData.idnentityType}}</el-descriptions-item>
              <el-descriptions-item label="经验要求">{{detailData.experience}}</el-descriptions-item>
              <!-- <el-descriptions-item label="支付方式">{{detailData.payType}}</el-descriptions-item> -->
            </el-descriptions>
            <div>支付方式：{{detailData.payType}}</div>
            <div style="padding: 20px;background: ghostwhite;">
              <div style="font-size: 16px;">采购描述：</div>
              <div>{{detailData.remark}}</div>
            </div>
          </div>

          <div style="margin-top:40px">
            <el-descriptions class="margin-top"
                             title="匹配公司"
                             :column="2">
              <template slot="extra">
                <el-button type="primary"
                           @click="pushClick()"
                           size="small">添加新公司</el-button>
              </template>
            </el-descriptions>
            <!-- 表格 -->
            <el-table ref="multipleTable"
                      :data="tableData"
                      tooltip-effect="dark"
                      style="width: 100%"
                      :header-cell-style="{ color: '#333' }"
                      @selection-change="handleSelectionChange">
              <div slot="empty"
                   class="emptyBg">
                <p>暂无数据</p>
              </div>
              <el-table-column type="selection"
                               width="55">
              </el-table-column>
              <el-table-column label="公司名称"
                               prop="compName">
              </el-table-column>
              <el-table-column prop="productName"
                               label="相关产品">
              </el-table-column>
              <el-table-column prop="exOperator"
                               label="运营人员"
                               show-overflow-tooltip>
              </el-table-column>

              <el-table-column prop="status"
                               label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status==0">待推送</span>
                  <span v-if="scope.row.status==1">待应答</span>
                  <span v-if="scope.row.status==2">已应答</span>
                  <span v-if="scope.row.status==3">忽略</span>
                </template>
              </el-table-column>

              <el-table-column label="操作"
                               width="180"
                               align="center">
                <template slot-scope="scope">

                  <div>
                    <el-button @click="danClick(scope.row,2)"
                               type="text"
                               v-if="scope.row.status==1||scope.row.status==2"
                               :disabled="scope.row.status==2?true:false"
                               size="small">
                      撤回
                    </el-button>

                    <!-- <el-popover :ref="scope.row.id"
                                placement="top"
                                width="160">
                      <p>您确定要删除这条数据吗？</p>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini"
                                   type="text"
                                   @click="visibleDelCancel(scope.row.id)">取消</el-button>
                        <el-button type="primary"
                                   size="mini"
                                   @click="visibleDelSubmit(scope.row)">确定</el-button>
                      </div> -->
                    <el-button type="text"
                               v-if="scope.row.status==3"
                               @click="danClick(scope.row,3)"
                               size="small"
                               slot="reference"
                               class="deleteCss">
                      再激活
                    </el-button>
                    <!-- </el-popover> -->

                    <el-button @click="danClick(scope.row,1)"
                               type="text"
                               v-if="scope.row.status==0"
                               size="small">
                      推送
                    </el-button>
                    <span class="verticalCss">|</span>

                    <!-- <el-popover :ref="scope.row.id"
                                placement="top"
                                width="160">
                      <p>您确定要删除这条数据吗？</p>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini"
                                   type="text"
                                   @click="visibleDelCancel(scope.row.id)">取消</el-button>
                        <el-button type="primary"
                                   size="mini"
                                   @click="visibleDelSubmit(scope.row)">确定</el-button>
                      </div> -->
                    <el-button type="text"
                               size="small"
                               slot="reference"
                               @click="danClick(scope.row,4)"
                               v-if="scope.row.status==1||scope.row.status==0"
                               class="deleteCss">
                      删除
                    </el-button>
                    <!-- </el-popover> -->
                    <el-button type="text"
                               size="small"
                               slot="reference"
                               v-if="scope.row.status==3||scope.row.status==2"
                               disabled>
                      删除
                    </el-button>
                  </div>

                </template>
              </el-table-column>
            </el-table>

            <!-- 批量 取消推送 -->

            <div style="margin-top:30px"
                 v-if="multipleSelection.length!=0">
              <el-button type="primary"
                         size="small"
                         @click="batchCancelPush(1)">
                推送
              </el-button>
              <el-button type=""
                         style="margin-left:20px"
                         plain
                         size="small"
                         @click="batchCancelPush(2)">
                撤回
              </el-button>
            </div>

          </div>

          </Col>
        </Row>
      </div>
    </div>

    <!-- 单条数据的弹窗 -->
    <el-dialog title="提示："
               :visible.sync="dialogInfo"
               width="30%"
               :close-on-click-modal="false">

      <div style="text-align: center;"
           v-if="danIndex==1">您确定要推送这条数据吗？</div>
      <div style="text-align: center;"
           v-if="danIndex==2">您确定要撤回这条数据吗？</div>
      <div style="text-align: center;"
           v-if="danIndex==3">您确定要再激活这条数据吗？</div>
      <div style="text-align: center;"
           v-if="danIndex==4">您确定要删除这条数据吗？</div>

      <span slot="footer"
            class="dialog-footer">
        <el-button type=""
                   size="small"
                   @click="dialogInfo = false">取消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="danSureClick()">确定</el-button>
      </span>
    </el-dialog>

    <!-- 批量数据的弹窗 -->
    <el-dialog title="提示："
               :visible.sync="dialogInfo_p"
               width="30%"
               :close-on-click-modal="false">

      <div style="text-align: center;"
           v-if="danIndex_p==1">您确定要批量推送这些数据吗？</div>
      <div style="text-align: center;"
           v-if="danIndex_p==2">您确定要批量撤回这些数据吗？</div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type=""
                   size="small"
                   @click="dialogInfo_p = false">取消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="danSureClick_p()">确定</el-button>
      </span>
    </el-dialog>

    <!-- 匹配 添加公司 -->
    <el-dialog title=" "
               :visible.sync="pushDialog"
               width="50%"
               :close-on-click-modal="false">
      <div style="display:flex">
        <!-- change-on-select -->
        <Cascader v-model="form.category"
                  :data="type"
                  filterable
                  :clearable=false
                  @on-change="changeCategory"
                  placeholder="输入关键词进行类别搜索"
                  style="width: 400px;"></Cascader>
        <Input search
               placeholder="请输入关键字"
               v-model="searchField"
               @on-search="searchPro()"
               style="width:230px;margin-left:20px;" />
      </div>

      <div style="margin-top:30px;overflow-y: auto;height: 400px">
        <Row :gutter="30" style="margin-left: 0; margin-right: 0;">
          <Col :sm="12"
               :md="12"
               v-for="(item, index) in allCategoryList"
               :key="index"
               class="w-20">
          <!-- <div style="background: ghostwhite;margin: 20px;padding: 20px;"
               @click="clickCompany(item)">
            <div v-for="(i, iIndex) in idsListComPid"
                 :key="iIndex">
              <el-button type="primary"
                         v-if="item.compId==i"
                         size="small">已选</el-button>
            </div>

            <p>所属公司：{{item.compId}}</p>
            <p v-if="item.productName.length>=30">产品：{{item.productName.substr(0,30)}}...</p>
            <p v-else>产品：{{item.productName}}</p>
          </div> -->
          <div style="display: flex;justify-content: space-between;margin:10px;border-radius:10px"
          :class="item.isShowBut?'changeBor':'changeBack'"
               @click="clickCompany(item,index)">
            <div style="padding: 20px;">
              <p>所属公司：{{item.name}}</p>
              <p v-if="item.productName.length>=30">产品：{{item.productName.substr(0,30)}}...</p>
              <p v-else>产品：{{item.productName}}</p>
            </div>
            <div v-if="item.isShowBut">
              <el-button type="primary"
                         size="small">已选</el-button>
            </div>
            <div v-if="item.isMatch">
              <el-button type="primary"
                         size="small">已匹配</el-button>
            </div>
          </div>
          </Col>
        </Row>
      </div>

      <span slot="footer"
            class="dialog-footer">

        <el-button type=""
                   size="small"
                   @click="pushDialog = false">取消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="addComClick()">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: '',
  data() {
    return {
      multipleSelection: [],
      pushDialog: false,
      typeValue: '',
      typeOptions: [],

      detailData: {},
      productTypeInfo: [],
      tableData: [],
      matchComList: [],
      type: [],
      form: {
        category: [],
      },
      searchField: '',
      idCategory: '', //最后一级的id
      allCategoryList: [], //根据id获取所属公司
      idsListComPid: [], //点击push 的id列表

      infoCom: '', //单条数据的信息
      dialogInfo: false, //
      titleDialog: '', //
      danIndex: 0, //

      dialogInfo_p: false, //
      danIndex_p: 0, //

      selectProList: [],
    }
  },
  components: {},
  computed: {
    $query() {
      return this.$route.query
    },
    ...mapGetters({
      user: 'getUser',
      uploadUrl: 'getUploadUrl',
      uploadVideoUrl: 'getUploadVideoUrl',
      formHeaders: 'getFormHeaders',
      company: 'loginModule/getCompany',
      hostExhibition: 'hostSetModule/getHostExhibition',
    }),
  },

  created() {
    this.init()
    this.initMatchingCompany()
    this.initProType()
  },
  methods: {
    ...mapActions({
      busOppNewRealeaseGetIdInfo: 'hostSetModule/busOppNewRealeaseGetIdInfo',
      busOppReleaseRelevancyDetailDelete:
        'hostSetModule/busOppReleaseRelevancyDetailDelete', //删除
      busOppNewRealeaseGetAllByReleaseId:
        'hostSetModule/busOppNewRealeaseGetAllByReleaseId',
      busOppReleaseRelevancyDetailPutUpdate:
        'hostSetModule/busOppReleaseRelevancyDetailPutUpdate', //修改状态
      busOppReleaseRelevancyDetailListPush:
        'hostSetModule/busOppReleaseRelevancyDetailListPush', //批量推送
      busOppReleaseRelevancyDetailListCancelPush:
        'hostSetModule/busOppReleaseRelevancyDetailListCancelPush', //批量取消推送
      busOppProductGetByCategoryIdDetail:
        'hostSetModule/busOppProductGetByCategoryIdDetail', //通过类别最后一级id 查询产品（供需使用）
      busOppProductlistAddDetail: 'hostSetModule/busOppProductlistAddDetail', //批量新增 公司
      getProductByGroupId: 'categoryModule/getProductByGroupId', // 获取  产品类别
    }),
    async init() {
      let res = await this.busOppNewRealeaseGetIdInfo(this.$query.id)
      if (res) {
        this.detailData = res
        this.clickIdCategory(res.categotyId)
        this.idCategory = res.categotyId

        const category = JSON.parse(res.productType)
        const categoryArr = []
        if(category){
        if (category.Value) {
          categoryArr.push(category.Value)
          if (category.List[0]) {
            categoryArr.push(category.List[0].Value)
            if (category.List[0].list) {
              categoryArr.push(category.List[0].list[0].Value)
            }
          }

          this.productType = categoryArr.join('/')
          this.form.category = categoryArr
        }
        }
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },

    async initMatchingCompany() {
      this.matchComList = []
      let res = await this.busOppNewRealeaseGetAllByReleaseId(this.$query.id)
      if (res) {
        this.tableData = res
        res.forEach((e) => {
          this.matchComList.push(e.sourceId)
        })
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },

    danClick(row, index) {
      this.infoCom = row
      this.dialogInfo = true
      this.danIndex = index
    },
    batchCancelPush(index) {
      this.danIndex_p = index

      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (index == 1) {
          if (this.multipleSelection[i].status == 1) {
            // this.$Message.warning('数据里面包含撤回的数据')
            this.$alert('数据里面包含撤回的数据', '提示', {
              confirmButtonText: '确定',
              callback: (action) => {},
            })
            return
          }
        }
        if (index == 2) {
          if (this.multipleSelection[i].status == 0) {
            // this.$Message.warning('数据里面包含推送的数据')
            this.$alert('数据里面包含推送的数据', '提示', {
              confirmButtonText: '确定',
              callback: (action) => {},
            })
            return
          }
        }
      }
      this.dialogInfo_p = true
    },

    danSureClick() {
      if (this.danIndex == 1) {
        this.pushSureChange()
      }
      if (this.danIndex == 2) {
        this.cancelSureChange()
      }
      if (this.danIndex == 3) {
        this.reactivationSureChange()
      }
      if (this.danIndex == 4) {
        this.deleteSureChange()
      }
    },
    danSureClick_p() {
      if (this.danIndex_p == 1) {
        this.pushSureChange_p()
      }
      if (this.danIndex_p == 2) {
        this.cancelSureChange_p()
      }
    },

    // 推送
    async pushSureChange() {
      let ids = []
      ids.push(this.infoCom.id)
      let res = await this.busOppReleaseRelevancyDetailListPush(ids)
      if (res.successed) {
        this.dialogInfo = false
        this.initMatchingCompany()
        this.$Message.success('操作成功')
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },
    // 推送   批量
    async pushSureChange_p() {
      let ids = []
      this.multipleSelection.forEach((e) => {
        ids.push(e.id)
      })
      let res = await this.busOppReleaseRelevancyDetailListPush(ids)
      if (res.successed) {
        this.dialogInfo_p = false
        this.initMatchingCompany()
        this.$Message.success('操作成功')
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },

    // 撤回
    async cancelSureChange() {
      let ids = []
      ids.push(this.infoCom.id)
      let res = await this.busOppReleaseRelevancyDetailListCancelPush(ids)
      if (res.successed) {
        this.dialogInfo = false
        this.initMatchingCompany()
        this.$Message.success('操作成功')
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },
    // 撤回 批量
    async cancelSureChange_p() {
      let ids = []
      this.multipleSelection.forEach((e) => {
        ids.push(e.id)
      })
      let res = await this.busOppReleaseRelevancyDetailListCancelPush(ids)
      if (res.successed) {
        this.dialogInfo_p = false
        this.initMatchingCompany()
        this.$Message.success('操作成功')
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },

    // 再激活
    async reactivationSureChange() {
      let opt = {
        id: this.infoCom.id,
        setValues: {
          status: 0,
        },
      }
      let res = await this.busOppReleaseRelevancyDetailPutUpdate(opt)
      if (res.successed) {
        this.dialogInfo = false
        this.initMatchingCompany()
        this.$Message.success('操作成功')
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },

    // 删除
    async deleteSureChange() {
      let res = await this.busOppReleaseRelevancyDetailDelete(this.infoCom.id)
      if (res.successed) {
        this.dialogInfo = false
        this.initMatchingCompany()
        this.$Message.success('操作成功')
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    visibleDelCancel(id) {
      // 取消
      this.$refs[id].doClose()
    },
    async visibleDelSubmit(rowData) {
      // 确定
      this.$refs[rowData.id].doClose()
      // 下面写 执行删除操作 deleteTicketUser
      //   let id = []
      //   id.push(rowData.id)
      //   let opt = {
      //     ticketIds: id,
      //   }

      let res = await this.busOppReleaseRelevancyDetailDelete(rowData.id)
      if (!res.successed) {
        let txt = '操作失败，请重新尝试'

        this.$message.error(txt)
      } else {
        this.initMatchingCompany()
        this.$message.success('操作成功！')
      }
    },
    // 查询产品类别
    async initProType() {
      let categoryData = await this.getProductByGroupId({
        groupId: this.hostExhibition.groupId,
        level: 0,
        loadChild: true,
      }) // 暂时先写死了值
      if (categoryData && categoryData.length) {
        categoryData.map((c) => {
          c.value = c.name
          c.label = c.name
          c.children = JSON.parse(JSON.stringify(c.list))
          c.children.map((v) => {
            v.value = v.name
            v.label = v.name
            v.children = JSON.parse(JSON.stringify(v.list))
            v.children.map((z) => {
              z.value = z.name
              z.label = z.name
              z.children = JSON.parse(JSON.stringify(z.list))
            })
          })
        })
        this.type = categoryData
      } else {
        this.type = []
      }
    },

    // 获取产品类别
    changeCategory(val) {
      let category = this.form.category
      if (val) {
        category = this.form.category = val
      }
      let data = null
      let idCategory = null
      this.type.forEach((c) => {
        if (category[0] && c.name === category[0]) {
          idCategory = c.id
          data = {
            Id: c.id,
            Value: c.name,
            List: [],
          }
          if (c.list && c.list.length && category[1]) {
            c.list.forEach((v) => {
              if (v.name === category[1]) {
                idCategory = v.id
                data.List[0] = {
                  Id: v.id,
                  Value: v.name,
                }
                if (v.list && v.list.length && category[2]) {
                  v.list.forEach((j) => {
                    if (j.name === category[2]) {
                      idCategory = j.id
                      data.List[0].list = [
                        {
                          Id: j.id,
                          Value: j.name,
                          Remark: j.tag,
                        },
                      ]
                    }
                  })
                }
              }
            })
          }
        }
      })
      console.log(idCategory)
      this.idCategory = idCategory
      this.clickIdCategory(idCategory)
      return data
    },

    searchPro() {
      this.clickIdCategory(this.idCategory)
    },
    async clickIdCategory(id) {
      let opt = {
        categoryId: id,
        pageSize: 99999,
        pageIndex: 1,
        Wheres: {
          type: 0,
          Wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                Wheres: {
                  WhereOperator: 6,
                  Label: 'name',
                  Value: `%${this.searchField || ''}%`,
                },
              },
            ],
          },
        },
      }
      let res = await this.busOppProductGetByCategoryIdDetail(opt)

      res.items.forEach((i) => {
        i.isShowBut = false
        i.isMatch = false
        // 匹配的公司
        this.matchComList.forEach((j) => {
          if (i.compId == j) {
            i.isMatch = true
          }
        })
        // 已选的
        this.idsListComPid.forEach((k) => {
          if (i.compId == k) {
            i.isShowBut = true
          }
        })
      })
      this.allCategoryList = res.items
    },

    pushClick(row) {
      this.pushDialog = true
      //   matchComList   匹配的公司 sourceId
      console.log(this.matchComList, '0000000')
      console.log(this.allCategoryList, '11111111')
      this.allCategoryList.forEach((m) => {
        m.isMatch = false
      })

      this.matchComList.forEach((i) => {
        this.allCategoryList.forEach((j) => {
          if (i == j.compId) {
            j.isMatch = true
          }
        })
      })
      console.log(this.allCategoryList, '2222222222222222')
    },

    // 弹窗点击事件
    clickCompany(row, eIndex) {
      if (this.allCategoryList[eIndex].isMatch) {
        // this.$message.error('已匹配不能点击')
        return
      }

      const index = this.idsListComPid.indexOf(row.compId)
      if (index >= 0) {
        this.idsListComPid.forEach((e, i) => {
          if (e == row.compId) {
            this.idsListComPid.splice(i, 1)
          }
        })
        // this.idsListComPid.splice(index, 1)
      } else {
        this.idsListComPid.push(row.compId)
      }

      if (this.allCategoryList[eIndex].isShowBut) {
        this.allCategoryList[eIndex].isShowBut = false
      } else {
        this.allCategoryList[eIndex].isShowBut = true
      }

      console.log(this.idsListComPid, '选择的数组')
      this.idsListComPid.forEach((p) => {
        this.allCategoryList.forEach((c) => {
          if (p == c.compId) {
            this.selectProList.push(c)
          }
        })
      })
      console.log(this.allCategoryList, ';;;;;;;;;;;')
      console.log(this.selectProList, ';ppppppppppppppppppppppp;')
    },

    // 添加新公司
    //     [
    //   {
    //     "exhibitionId": "组数据里面拿",
    //     "sourceId": "公司id",
    //     "productName": "产品名称",
    //     "releaseId": "路由Id",
    //     "linkPerson": "",
    //     "status": 0,
    //   }
    // ]
    async addComClick() {
      // 先把 selectProList  这个数组只是为了拿到productName    去重

      let hash = {}
      const data2 = this.selectProList.reduce((preVal, curVal) => {
        hash[curVal.compId]
          ? ''
          : (hash[curVal.compId] = true && preVal.push(curVal))
        return preVal
      }, [])

      let lists = []
      let data = {}
      this.idsListComPid.forEach((e) => {
        data2.forEach((v) => {
          if (e == v.compId) {
            data.exhibitionId = this.detailData.exhibitionId
            data.sourceId = v.compId
            data.productName = v.productName
            data.releaseId = this.$query.id
            data.linkPerson = ''
            data.status = 0
            lists.push(data)
            data={}
          }
        })
      })
      console.log(data)
      console.log(lists)
      let res = await this.busOppProductlistAddDetail(lists)
      if (res.successed) {
          this.idsListComPid=[]
        this.pushDialog = false
        this.initMatchingCompany()
         this.clickIdCategory(this.idCategory)
        this.$Message.success('操作成功')
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.ie-icon {
  line-height: 31px;
  padding-left: 30px;
  .ivu-icon {
    font-size: 22px;
    cursor: pointer;
    font-size: 22px;
    color: #118eea;
  }
  &.z-remove {
    color: #d71f06;
  }
}
.addcase {
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 900px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
.deleteCss {
  color: #ff4c4c;
}
.verticalCss {
  color: #c8c8c8;
}

// #359eff
.changeBor{
    border: 1px #359eff solid;
    color: #359eff;

}
.changeBack{
    background: #fafafa;
}

</style>
